import CryptoJS from "crypto-js";

/**
 * 加密方法
 */
export function encrypt(text, secretKey) {
  const keyHex = CryptoJS.enc.Base64.parse(secretKey);
  const ivHex = keyHex.clone();
  // 前16字节作为向量
  ivHex.sigBytes = 16;
  ivHex.words.splice(4);
  const messageHex = CryptoJS.enc.Utf8.parse(text);
  const encrypted = CryptoJS.AES.encrypt(messageHex, keyHex, {
    "iv": ivHex,
    "mode": CryptoJS.mode.CBC,
    "padding": CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}

/**
* 解密方法
*/
export function decrypt(textBase64, secretKey) {
  var keyHex = CryptoJS.enc.Base64.parse(secretKey);
  var ivHex = keyHex.clone();
  // 前16字节作为向量
  ivHex.sigBytes = 16;
  ivHex.words.splice(4);
  var decrypt = CryptoJS.AES.decrypt(textBase64, keyHex, {
    "iv": ivHex,
    "mode": CryptoJS.mode.CBC,
    "padding": CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Utf8.stringify(decrypt);
}

export function generateAESKey() {
  const keySize = 16; // 设置key的大小为256位，即32个字节
  const key = CryptoJS.lib.WordArray.random(keySize); // 生成随机的key
  const base64Key = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(key)); // 转换为base64格式的字符串
  return base64Key; // 输出生成的AES key
}
export function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
